import { Box, Stack, Typography } from '@mui/material'
import { Outlet } from 'react-router-dom'

import { BrandMark } from '@/components/common/BrandMark'
import { surfaces } from '@/theme'

export function AuthLayout() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
      }}
    >
      <Stack
        justifyContent="center"
        alignItems="center"
        sx={{ px: { xs: 3, sm: 6 }, py: 6, bgcolor: 'background.default' }}
      >
        <Box sx={{ width: '100%', maxWidth: 400 }}>
          <Outlet />
        </Box>
      </Stack>

      <Box
        sx={{
          display: { xs: 'none', md: 'flex' },
          position: 'relative',
          flexDirection: 'column',
          justifyContent: 'space-between',
          p: 6,
          overflow: 'hidden',
          // UX-9 Brand Phase C — el resplandor original estaba centrado
          // en "30% 10%" (esquina superior izquierda), exactamente donde
          // se apoya la marca — el isotipo perdía contraste al mezclarse
          // con el propio glow. Solución (preferencia 1 del encargo:
          // reposicionar el resplandor, no tocar el isotipo/wordmark):
          // se mueve el centro a la esquina inferior derecha ("85% 92%"),
          // lejos de la marca y del titular, dejando la zona de arriba
          // limpia (solo el color base `surfaces.sidebar`, sin glow) —
          // el isotipo queda sobre fondo plano, con contraste real. De
          // paso se corrige el tono: `rgba(76,111,255,...)` era el azul
          // ANTIGUO del placeholder (`#4C6FFF`, ya retirado en Fase A) —
          // ahora usa el azul oficial `#2563FF` (`rgb(37,99,255)`), el
          // mismo del isotipo — mismo motivo de marca, no un color nuevo.
          background: `radial-gradient(ellipse 70% 55% at 85% 92%, rgba(37,99,255,0.22) 0%, rgba(8,11,18,0) 60%), ${surfaces.sidebar}`,
          borderLeft: `1px solid ${surfaces.border}`,
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <BrandMark size={32} />
          <Typography variant="h6" sx={{ letterSpacing: '-0.01em', fontWeight: 700 }}>
            GOVIA
          </Typography>
        </Stack>

        <Stack spacing={2} sx={{ maxWidth: 460 }}>
          <Typography variant="h2">Inteligencia gubernamental impulsada por IA.</Typography>
          <Typography variant="body1" color="text.secondary">
            Territorio, dependencias y decisiones en una sola plataforma ejecutiva:
            monitoreo en tiempo real, análisis territorial y asistencia de IA para
            equipos de gobierno.
          </Typography>
        </Stack>

        <Typography variant="caption" color="text.secondary">
          © {new Date().getFullYear()} GOVIA. Todos los derechos reservados.
        </Typography>
      </Box>
    </Box>
  )
}
